/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Artifact_Confirm_CreatingInputs */



/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {Chat_Artifact_Confirm_CreatingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_artifact_confirm_creating = /** @type {((inputs?: Chat_Artifact_Confirm_CreatingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Artifact_Confirm_CreatingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird erstellt...")
	return /** @type {LocalizedString} */ ("Creating...")
});